module.exports = __webpack_public_path__ + "img/ic-mode-edit.643c3361.svg";